const CHIPS = ['Data Infuser', 'AI Data Verifier', 'Data Map', 'Doc Infuser', 'QuFa Studio'];

/** 브랜드 마무리 — 데이터 전 주기 메시지 + 솔루션 칩. (CTA 버튼 없음) */
export default function Closing() {
  return (
    <section className="pd-section pd-closing">
      <div className="pd-container">
        <div className="pd-closing__inner">
          <h2 className="pd-closing__title">
            데이터 개방부터 검증·품질관리까지,
            <br />
            <span className="pd-grad">공공데이터의 전 주기</span>를 함께 설계합니다
          </h2>
          <div className="pd-closing__chips">
            {CHIPS.map((c) => (
              <span className="pd-chip" key={c}>
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
